import React from "react";
import ProfileTitle from "../../../../components/ProfileTitle";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import useAntTable from "../../../../utils/useAntTable";
import * as api from '../../../../apis/platforms/admin/baseData'
import {Button, Divider, Popconfirm, Space} from "antd";
import DealerNatureEditModal from "./dealerNatureEditModal";
import useFormModal from "../../../../utils/useFormModal";
import {useRequest} from "ahooks";

export default function DealerNature() {

    const {tableProps, refresh} = useAntTable(api.getDealerNatures, {})

    const {setVisible, modalProps} = useFormModal({
        onRequest: api.editDealerNature,
        onOk: () => {
            setVisible(false)
            refresh()
        }
    })

    const {run: onDelete} = useRequest(api.deleteDealerNature, {
        manual: true,
        onSuccess: () => {
            refresh()
        }
    })

    const columns: StandardColumnsType = [
        {
            title: '编码',
            dataIndex: 'code'
        },
        {
            title: '客户性质',
            dataIndex: 'dealerNature'
        },
        {
            title: '描述',
            dataIndex: 'desc'
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <Space split={<Divider type="vertical" />}>
                    <a onClick={() => {
                        setVisible(true, record)
                    }}>编辑</a>
                    <Popconfirm title={'是否确认删除'} onConfirm={() => onDelete(record.id)}>
                        <a>删除</a>
                    </Popconfirm>
                </Space>
            )
        }
    ]

    return (
        <div>
            <ProfileTitle>客户性质</ProfileTitle>
            <StandardTable {...tableProps} columns={columns} showCard={false} rowKey={'id'} toolbar={
                <Button type={'primary'} onClick={() => setVisible(true)}>新增</Button>
            }/>
            <DealerNatureEditModal {...modalProps}/>
        </div>
    )
}
